import React from "react";
import ReactInputMask from "react-input-mask";
import { IoSearch } from "react-icons/io5";
import {
  checkMembershipNoMask,
  extractNumber,
  getHelperText,
} from "../functions";

const MaskedInput = ({ stateKey, type, state, setState, error = false }) => {
  let helperTextColor = error ? "text-red" : "text-stone-600";
  let inputTextColor = error ? "text-red" : "text-black";

  const onChangeVal = (e) => {
    setState({ ...state, [stateKey]: extractNumber(e) });
  };

  return (
    <ReactInputMask
      mask={checkMembershipNoMask(type)}
      value={state[stateKey]}
      onChange={onChangeVal}
      placeholder={`Enter your ${type === "NIC" ? "C" + type : type}#`}
    >
      {(inputProps) => (
        <section>
          <div className="searchInput mb-2">
            <input
              {...inputProps}
              type="text"
              autoFocus
              required
              className={
                "outline-none py-3 px-3.5 rounded-l w-full " + inputTextColor
              }
            />
            <button>
              <IoSearch className="text-lg" />
            </button>
          </div>
          <p className={"text-sm ml-3 " + helperTextColor}>
            {getHelperText(type)}
          </p>
        </section>
      )}
    </ReactInputMask>
  );
};

export default MaskedInput;
